export class Review {
  constructor(review = {}) {
    this.id = review.id;
    this.grade = review.grade;
    this.comment = review.comment;
    this.status = review.status;
    this.createdAt = review.created_at;
  }
}
